import { DashboardRecommendedListsDataResponseDto } from 'src/app/shared/dto/dashboard-recommended-lists-data.dto';

export const RECOMMENDED_LISTS_DATA: DashboardRecommendedListsDataResponseDto[] = [
    {
        title: 'Company Types',
        items: [
            {
                id: 'federalcontractors',
                name: 'Federal Contractors',
                tag: 'federal_contractors'
            },
            {
                id: 'managedServiceProviders',
                name: 'Managed Service Providers (MSPs)',
                tag: 'managed_service_providers'
            },
            {
                id: 'publicCompanies',
                name: 'Public Companies',
                tag: 'public_companies'
            },
            {
                id: 'valueAddedResellers',
                name: 'Value-Added Resellers (VARs)',
                tag: 'value_added_resellers'
            }
        ]
    },
    {
        title: 'Ranking Lists',
        items: [
            {
                id: 'fast100',
                name: '100 Fastest Growing',
                tag: '100_fastest_growing'
            },
            {
                id: 'fast500',
                name: 'Fast 500 Deloitte',
                tag: 'fast_500_deloitte'
            },

            {
                id: 'forbesglobal2000',
                name: 'Forbes Global 2,000',
                tag: 'forbes_global_2000'
            },
            {
                id: 'fortune500',
                name: 'Fortune 500',
                tag: 'fortune_500'
            },
            {
                id: 'fortune1000',
                name: 'Fortune 1,000',
                tag: 'fortune_1000'
            },
            {
                id: 'inc5000',
                name: 'Inc 5,000',
                tag: 'inc_5000'
            },
            {
                id: 'linkedinTopStartups2021',
                name: 'LinkedIn Top Startups',
                tag: 'linkedin_top_startups_2021'
            },
            {
                id: 'saas1000',
                name: 'SaaS 1,000',
                tag: 'saas_1000'
            },
        ]
    }
]